export default {}



// WEBPACK FOOTER //
// ./src/page/int/face/hikFaceAuth/lang/index.en.js